import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const AuthGuard = ({ children }) => {
    const { isAuthenticated, isInitialised } = useAuth();
    const location = useLocation();

    if (!isInitialised) return null;
    if (!isAuthenticated) {
        return (
            <Redirect
                to={{ pathname: "/login", state: { from: location } }}
            />
        );
    }
    return <>{children}</>;
};

export default AuthGuard;
